import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", null, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "gradient",
        x1: "-9.98523",
        y1: "7.98818",
        x2: "5.60147",
        y2: "27.4716",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", { "stop-color": "#00FFAA" }),
        _createElementVNode("stop", {
          offset: "0.517251",
          "stop-color": "#4579F5"
        }),
        _createElementVNode("stop", {
          offset: "0.999815",
          "stop-color": "#9C42F5"
        })
      ])
    ], -1)
  ]))]))
}